const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://syaycili.github.io/',
  title: 'SY',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Sarp Yaycılı',
  role: 'Full Stack Developer',
  description:
    'Türk Eğitim Vakfı İnanç Türkeş Özel Lisesi 11. Sınıf öğrencisi ve Full Stack Developer. PHP üzerinden web uygulamaları geliştirmekteyim. Projelerimde Laravel ve Vue.js kullanmaktayım.',
  resume: 'https://syaycili.github.io/sarpyaycili_cv.docx',
  social: {
    linkedin: 'https://www.linkedin.com/in/sarpyaycili/',
    github: 'https://github.com/syaycili/',
  },
} 

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'meetuptoteamup.com',
    description:
      'meetuptoteamup.com kullanıcıların takım arkadaşları bulmasına, takım kurmasına ve birbirleri ile iletişim halinde projeler geliştirmesine yardımcı olan online bir platformdur.',
    stack: ['Laravel', 'Vue.js', 'MySQL'],
    sourceCode: 'https://github.com/syaycili/meetuptoteamup',
    livePreview: 'https://www.meetuptoteamup.com',
  },
  {
    name: 'matcevap.ninja',
    description:
      'Matcevap.ninja kullanıcıların matematik ödevlerinde yardım alabileceği ve diğer kullanıcılara yardım edebileceği, soru paylaşım platformudur.',
    stack: ['PHP', 'HTML', 'CSS', 'Javascript'],
    sourceCode: 'https://www.github.com/syaycili/matcevap.ninja',
    livePreview: 'https://matcevap.ninja/',
  },
  {
    name: 'Hexagon Takım Sitesi',
    description:
      'Hexagon Robotik Takımının resmi web sitesi. HTML, CSS ve Javascript ile yapılmış statik web sitesi.',
    stack: ['HTML', 'CSS', 'Javascript'],
    sourceCode: 'https://github.com/syaycili/Hexagon-Web-App',
    livePreview: 'https://hexagon-vex.web.app/',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'PHP',
  'Laravel',
  'Git',
  'HTML',
  'CSS',
  'JavaScript',
  'Vue',
  'Bootstrap',
  'Tailwind CSS',
  'MySQL',
  'Apache',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'sarpyaycili@gmail.com',
}

export { header, about, projects, skills, contact }
